// Scritture su localStorage a prova di quota piena.
//
// La quota è ~5MB per dominio ed è condivisa da TUTTE le chiavi. Le cache CRUD
// per-modello (crud_filters_cache_*, crud_info_cache_*) la saturano da sole:
// finché ogni famiglia libera solo le proprie chiavi il totale resta incollato
// al tetto e a fallire è la prima scrittura importante che capita — al login il
// profilo utente (user-details può superare i 500KB), con l'eccezione scambiata
// per errore di autenticazione e logout immediato.
//
// Qui lo sfratto è condiviso: su quota piena si liberano tutte le cache
// rigenerabili, non solo quelle della famiglia che sta scrivendo.

// Chiavi ricostruibili con una chiamata API: possono essere buttate senza
// perdere nulla se non un po' di reattività al primo caricamento.
const REGENERABLE_KEY = /^crud_(filters|info)_cache_/

// Firefox storico usa nome e codice diversi da QuotaExceededError.
export function isQuotaExceeded(error) {
	return !!error && (error.name === 'QuotaExceededError'
		|| error.name === 'NS_ERROR_DOM_QUOTA_REACHED'
		|| error.code === 22
		|| error.code === 1014)
}

// Rimuove le cache rigenerabili, tranne quella indicata (chi sta scrivendo non
// ha motivo di cancellare il valore che sta per riscrivere).
// Ritorna il numero di chiavi liberate.
export function evictRegenerableCaches(exceptKey = null) {
	// Prima si fotografano le chiavi, poi si rimuove: l'ordine di localStorage.key(i)
	// non è garantito stabile dopo una removeItem, e scorrere per indice mentre si
	// cancella lascia indietro qualche chiave (osservato in Chrome con storage pieno).
	const keys = []
	for (let i = 0; i < localStorage.length; i++) {
		keys.push(localStorage.key(i))
	}

	let evicted = 0
	keys.forEach(key => {
		if (key && key !== exceptKey && REGENERABLE_KEY.test(key)) {
			localStorage.removeItem(key)
			evicted++
		}
	})
	return evicted
}

// Scrive la chiave; se la quota è piena libera le cache rigenerabili e ritenta
// una volta sola. Ritorna true se il valore è finito in storage.
// Non lancia mai: sta al chiamante decidere se il fallimento è rilevante.
export function safeLocalStorageSet(key, value) {
	try {
		localStorage.setItem(key, value)
		return true
	} catch (e) {
		// Storage disabilitato (private mode, policy): non c'è spazio da liberare.
		if (!isQuotaExceeded(e)) {
			return false
		}
		try {
			evictRegenerableCaches(key)
			localStorage.setItem(key, value)
			return true
		} catch (e2) {
			// Valore più grande della quota residua: si prosegue senza cache.
			return false
		}
	}
}
